import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useContext } from 'react';
import StyledButton from './Button.styles';
import PaginationContext from '../data/PaginationContext';

var Button = function Button(props) {
  var pageNumber = props.pageNumber,
      children = props.children,
      paginationInfo = props.paginationInfo,
      inputProps = _objectWithoutProperties(props, ["pageNumber", "children", "paginationInfo"]);

  var _ref = useContext(PaginationContext) || paginationInfo,
      page = _ref.page,
      changePage = _ref.changePage;

  var handlePageChange = function handlePageChange() {
    if (pageNumber && pageNumber !== page) {
      changePage(pageNumber);
    }
  };

  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(StyledButton, _extends({}, inputProps, {
      onClick: handlePageChange
    }), children)
  );
};

export default Button;